import { useEffect, useState } from "react";
import CookieConsent, { SAME_SITE_OPTIONS } from "react-cookie-consent";
import { useLocation } from "react-router-dom";
import {
  ANALYTICS_CONSENT_COOKIE,
  hasAnalyticsConsent,
} from "../utils/analyticsConfig";
import { trackPageView } from "../utils/analytics";

export default function AnalyticsConsent() {
  const location = useLocation();
  const [consentGranted, setConsentGranted] = useState(hasAnalyticsConsent);

  useEffect(() => {
    if (!consentGranted) return;

    trackPageView({
      path: `${location.pathname}${location.search}${location.hash}`,
      navigationKey: location.key,
    });
  }, [
    consentGranted,
    location.hash,
    location.key,
    location.pathname,
    location.search,
  ]);

  return (
    <CookieConsent
      location="bottom"
      cookieName={ANALYTICS_CONSENT_COOKIE}
      cookieValue="true"
      declineCookieValue="false"
      enableDeclineButton
      setDeclineCookie
      buttonText="Accept"
      declineButtonText="Decline"
      ariaAcceptLabel="Accept analytics and advertising cookies"
      ariaDeclineLabel="Decline analytics and advertising cookies"
      onAccept={() => setConsentGranted(true)}
      onDecline={() => setConsentGranted(false)}
      sameSite={SAME_SITE_OPTIONS.LAX}
      expires={365}
      containerClasses="CookieConsent studyradar-cookie-consent"
      contentClasses="cookie-consent"
      buttonClasses="cookie-accept-btn"
      declineButtonClasses="cookie-decline-btn"
      disableButtonStyles
      flipButtons
    >
      <strong>Cookie preferences</strong>
      <span>
        We use analytics and advertising cookies to understand product usage and
        improve our services. See our <a href="/privacy-policy">Privacy Policy</a>.
      </span>
    </CookieConsent>
  );
}
